import http from '../utils/request'
import Cookies from 'js-cookie'

export function getCookiesToken() {
    var token = Cookies.get('token');
    token = 'Bearer ' + token;
    return token;
}

export function getTaoyuanTechCookies() {
    var cookies = Cookies.get('taoyuan_tech_cookies');
    if (cookies) {
        cookies = cookies;
    } else {
        cookies = '';
    }
    return cookies;
}

// 请求首页数据
export const getUsers = (per_page, page_num, query=null) => {
    var token = getCookiesToken();
    var url_str = '/admin/users?per_page=' + per_page + '&page_num=' + page_num;
    if (query) {
        url_str += '&query=' + query;
    }
    // 返回一个promise对象
    return http.get(url_str, {
        headers: {
            'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Authorization': token
        }
    });
}

export const getBarcodeUrl = (data) => {
    var token = getCookiesToken();
    return http.post('/admin/barcode', data, {
        headers: {
            'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Authorization': token
        }
    });
}

export const getDevices = (page, size) => {
    var token = getCookiesToken();
    var url = '/admin/devices?page_num=' + page + '&per_page=' + size
    return http.get(url, {
        headers: {
            'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Authorization': token
        }
    })
}

export const getDeviceConnectState = (serial_code) => {
    var token = getCookiesToken();
    return http.get('/admin/devices/'+serial_code+'/connect-state', {
        headers: {
            'content-type': 'application/x-www-form-urlencoded; charset=UTF-8', 
            'Authorization': token
        }
    })
}

export const searchDevice = (val) => {
    var token = getCookiesToken();
    var url = '/admin/search?kw=' + val
    return http.get(url, {
        headers: {
            'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Authorization': token
        }
    })
}
export const login = (formData) => {
    // console.log('login form:', formData.username, formData.password)
    return http.post('/admin/login', {
        username: formData.username,
        password: formData.password
    }, {
        headers: { 'content-type': 'application/x-www-form-urlencoded; charset=UTF-8' }
    })
}

export const loginTaoyuanTech = () => {
    var token = getCookiesToken();
    return http.post('/admin/taoyuan/login', {}, { 
        headers: {
            'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Authorization': token
         }
    })
}

export const getSimCardGroups = () => {
    var cookies = getTaoyuanTechCookies();
    var token = getCookiesToken();
    return http.post('/admin/taoyuan/expiry_cards_count', {
        taoyuan_cookies: cookies
    }, {
        headers: {
            'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Authorization': token
        }
    })
}

export const getExpirySimCards = (cu_edate_month, page=1, psize=10) => {
    var cookies = getTaoyuanTechCookies();
    var token = getCookiesToken();
    return http.post('/admin/taoyuan/expiry_cards', {
        taoyuan_cookies: cookies,
        cu_edate_month: cu_edate_month,
        page: page,
        psize: psize
    }, {
        headers: {
            'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Authorization': token
        }
    })
}

export const getUserInfo = (quid) => {
    var token = getCookiesToken();
    return http.post('/admin/user_account', {
        uid: quid
    }, {
        headers: {
            'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Authorization': token
        }
    })
}

export const getBeltInfo = (qdid) => {
    var token = getCookiesToken();
    return http.post('admin/device', {
        did: qdid
    }, {
        headers: {
            'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Authorization': token
        }
    })
}

export const getPetInfoByDevice = (serial) => {
    var token = getCookiesToken();
    return http.get('admin/devices/'+serial+'/pet', {
        headers: {
            'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Authorization': token
        }
    });
}

export const getEphemerisMeta = () => {
    var token = getCookiesToken();
    return http.get('/admin/ephemeris/meta', {
        headers: {
            'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Authorization': token
        }
    })
}

export const getSimCardInfo = (qSC) => {
    var token = getCookiesToken();
    return http.get('admin/devices/'+qSC+'/sim-card', {
        headers: {
            'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Authorization': token
        }
    })
}

export const getSignal4G = (qSC, date) => {
    var token = getCookiesToken();
    return http.get('admin/device/signal?serial='+qSC+'&date='+date, {
        headers: {
            'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Authorization': token
        }
    })
}

export const getHistoryTrack = (qSC, date) => {
    var token = getCookiesToken();
    return http.post('admin/trajectory', {
        serial_code: qSC,
        date: date
    }, {
        headers: {
            'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Authorization': token
        }
    })
}

export const getHistoryMotion = (qSC, date) => {
    var token = getCookiesToken();
    return http.post('admin/motion', {
        serial_code: qSC,
        from_date: date,
        to_date: date
    }, {
        headers: {
            'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Authorization': token
        }
    })
}

            /*let fd = new FormData()  
            fd.append('file', fileObj) 
            fd.append('platNum', this.importList.platNum)  
            fd.append('taskName', this.importList.taskName)
            let url = process.env.CMS1_BASE_API + 'cdnDel/uploadExcel'let 
            config = {headers: {'Content-Type': 'multipart/form-data'    }  }  
            axios.post(url, fd, config).then(res=>{if(res.code===0){this.submitForm();   }  })}*/

export const uploadBeltFW = (fd, config) => {
    var token = getCookiesToken();
    console.log("uploadBeltFW config = ", config);
    config.headers.Authorization = token;
    return http.post('/firmware/add_update', fd, config);
}

export const getBootFirmwares = (page, size) => {
    var token = getCookiesToken();
    console.log('Get belt boot firmwares, ', page, size);

    // var config = {headers: {'Authorization': token}, withCredentials: false};
    return http.get('/admin/boot_firmwares?page=' + page + '&size=' + size, {
        headers: {
            'Authorization': token
        }
    });
}

/**
 * 不分页获取全部的BOOT固件信息，用于在下拉框中填入数据
 * @returns res.data.data = [30, 31, ...]
 */
export const getAllBootFirmwares = () => {
    var token = getCookiesToken();
    
    return http.get('/admin/all_boot_firmwares', {
        headers: {
            'Authorization': token
        }
    });
}

/**
 * 分页获取APP固件列表
 * @param {int} page 当前页数
 * @param {int} size 每页的条数
 * @returns 
 */
export const getAppFirmwares = (page, size) => {
    var token = getCookiesToken();
    console.log('Get App firmwares, ', page, size);
    // var config = {headers: {'Authorization': token}, withCredentials: false};
    return http.get('/admin/app_firmwares?page=' + page + '&size=' + size, {
        headers: {
            'Authorization': token
        }
    });
}

/**
 * @returns 获取所有的硬件版本信息
 */
export const getHardwares = () => {
    var token = getCookiesToken();
    
    return http.get('/admin/hardwares', {
        headers: {
            'Authorization': token
        }
    }).then(res => {
        console.log('获取所有硬件版本号resp: ', res)
        if (res.status === 200 && res.data.code === 200) {
            return res.data.data;
        }
    }).catch(error => {
        return null;
    });
}

/**
 * 添加新的硬件版本信息
 * @param {int} ver 
 * @returns 
 */
export const addHardware = (ver) => {
    var token = getCookiesToken();
    console.log('add hardware version = ', ver);

    return http.post('/admin/hardwares', {
        version: ver
    }, {
        headers: {
            'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Authorization': token
        }
    });
}

/**
 * 上传新的BOOT固件信息
 * @param {FormData} formData 
 * @returns 
 */
export const uploadBootFW = (formData) => {
    var token = getCookiesToken();
    console.log('add boot fw form data:', formData);

    return http.post('/admin/boot_firmwares', formData, {
        headers: {
            'Content-Type': 'multipart/form-data; charset=UTF-8',
            'Authorization': token
        }
    });
}

/**
 * 上传新的APP固件信息
 * @param {FormData} formData 
 * @returns 
 */
export const uploadAppFW = (formData) => {
    var token = getCookiesToken();
    console.log('upload app form data: ', formData);

    return http.post('admin/app_firmwares', formData, {
        headers: {
            'Content-Type': 'multipart/form-data; charset=UTF-8',
            'Authorization': token
        }
    });
}

/**
 * 只更新BOOT固件文件或BOOT固件支持的硬件信息
 * @param {FormData} formData 
 * @returns 
 */
export const updateBootFW = (formData) => {
    var token = getCookiesToken();
    console.log('update boot form data: ', formData);

    return http.patchForm('/admin/boot_firmwares', formData, {
        headers: {
            'Authorization': token
        }
    });
}

/**
 * 更新APP固件的文件或支持的硬件信息
 * @param {FormData} formData 
 * @returns 
 */
export const updateAppFW = (formData) => {
    var token = getCookiesToken();
    console.info('update app form data: ', formData);

    return http.patchForm('/admin/app_firmwares', formData, {
        headers: {
            'Authorization': token
        }
    });
}

/**
 * 根据BOOT固件版本号获取这个BOOT固件的信息，包括硬件支持的信息
 * @param {int} boot_ver BOOT固件版本号
 */
export const getBootFWSupports = (boot_ver) => {
    var token = getCookiesToken();

    return http.get('/admin/boot_firmwares/supports/' + boot_ver, {
        headers: {
            'Authorization': token
        }
    });
}

/**
 * 根据APP固件版本号获取这个APP固件支持的硬件和BOOT固件信息
 * @param {int} app_ver 
 * @returns 
 */
export const getAppFWSupports = (app_ver) => {
    var token = getCookiesToken();

    return http.get('/admin/app_firmwares/supports/' + app_ver, {
        headers: {
            'Authorization': token
        }
    });
}


export const formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000); // 如果是秒级时间戳
    const Y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const H = String(date.getHours()).padStart(2, '0');
    const M = String(date.getMinutes()).padStart(2, '0');
    const S = String(date.getSeconds()).padStart(2, '0');
    return `${Y}-${m}-${d} ${H}:${M}:${S}`;
}


export const convertSimStatus = (status_code) => {
    switch (status_code) {
        case 0:
            return '未知';
        case 1:
            return '测试期';
        case 2:
            return '沉默期';
        case 3:
            return '使用中';
        case 4:
            return '停机';
        case 5:
            return '停机保号';
        case 6:
            return '预销号';
        case 7:
            return '销号';
        default:
            return '错误';
    }
}